import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { isDropLive } from "@/lib/drop";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import DropCountdown from "@/pages/DropCountdown";

const toaster = (
  <Toaster
    theme="light"
    position="bottom-right"
    toastOptions={{
      style: {
        background: "#ffffff",
        border: "1px solid hsl(214 32% 88%)",
        color: "hsl(222 47% 11%)",
        fontFamily: "Archivo, sans-serif",
      },
    }}
  />
);

function App() {
  const bypass =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("preview") === "1";
  const [live, setLive] = useState(isDropLive() || bypass);

  useEffect(() => {
    if (live) return;
    const id = setInterval(() => {
      if (isDropLive()) {
        setLive(true);
        clearInterval(id);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [live]);

  return (
    <div className="App grain">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <LanguageProvider>
          <CartProvider>
            {live ? (
              <>
                <Navbar />
                <CartDrawer />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/drop" element={<DropCountdown />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="*" element={<Home />} />
                </Routes>
                <Footer />
              </>
            ) : (
              <Routes>
                <Route path="*" element={<DropCountdown locked />} />
              </Routes>
            )}
            {toaster}
          </CartProvider>
          </LanguageProvider>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
